/**
 * Host bazlı CookieYes yapılandırması.
 *
 * `id` CookieYes panelindeki script URL'sinden alınır:
 *   https://cdn-cookieyes.com/client_data/<ID>/script.js
 *
 * Geçerli bir `id` girilen host'ta CookieYes, OneTrust'ın yerine geçer
 * (bkz. utils/consentProvider.ts → CookieYes önceliklidir). `id` boş/geçersiz
 * kaldığı sürece o host için OneTrust yüklenmeye devam eder; bu sayede TR
 * geçişi tek satırlık bir config değişikliğiyle yapılır.
 *
 * Davranış bayrakları host'a göre değişir:
 *  - consentModel 'implied' (KVKK / TR): sayfa geçişinde örtülü kabul, Google Consent Mode
 *    default'u granted (OneTrust dönemi paritesi), reddeden kullanıcıda GTM yüklenmez.
 *    GDPR pazarlarında (wingie.de) 'explicit': CookieYes'in varsayılan opt-in davranışı, ek kod yok.
 *  - migrateFromOneTrust: host daha önce OneTrust kullandıysa OneTrust→CookieYes consent
 *    migration script'i basılır (utils/cookieConsentMigration.ts).
 *  - bannerCustomizations: enuygunsigorta.com (kasko-nextjs) ile aynı banner tasarımı için
 *    "Reddet" linki, "Seçimleri Onayla" ve "Tümüne İzin Ver" davranışları
 *    (utils/cookieYesBannerCustomizations.ts, hooks/useCookieYesAcceptAllButton.ts).
 */
export type CookieYesConsentModel = 'implied' | 'explicit'

export interface CookieYesDomainConfig {
  market: string
  id: string
  host: string
  consentModel: CookieYesConsentModel
  migrateFromOneTrust: boolean
  bannerCustomizations: boolean
}

export const COOKIEYES_ENUYGUN_ID = 'e1546ffbdccd0ccbc77dfae48279e76d'

export const cookieYesDomainsID: CookieYesDomainConfig[] = [
  { market: 'de', id: '5cdba96be61e259541f9ee41', host: 'wingie.de', consentModel: 'explicit', migrateFromOneTrust: false, bannerCustomizations: false },
  { market: 'tr', id: COOKIEYES_ENUYGUN_ID, host: 'www.enuygun.com', consentModel: 'implied', migrateFromOneTrust: true, bannerCustomizations: true },
]
